<template>
  <CRow>
    <CCol>
      <CCard>
        <div class="judul">
          <strong>Detail Career - Applicant</strong>
        </div>
        <CCardHeader>
          <strong>Data Diri Pendaftar</strong>
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Registration ID"
                class="mb-0"
                placeholder="Registration ID"
                v-model.trim="candidateData.candidate_id"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Tanggal Submission"
                class="mb-0"
                placeholder="Tanggal Submission"
                v-model.trim="candidateData.created_at"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Lengkap"
                class="mb-0"
                placeholder="Nama Lengkap"
                v-model.trim="candidateData.candidate_name"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Tanggal Lahir"
                class="mb-0"
                placeholder="Tanggal Lahir"
                v-model.trim="candidateData.candidate_date_of_birth"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Email"
                class="mb-0"
                v-model.trim="candidateData.candidate_email"
                placeholder="Email"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="No. HP"
                class="mb-0"
                v-model="candidateData.candidate_phone_number"
                placeholder="No. HP"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Jenis Kelamin"
                class="mb-0"
                v-model.trim="candidateData.candidate_gender"
                placeholder="Jenis Kelamin"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Posisi Yang Dilamar"
                class="mb-0"
                v-model.trim="candidateDataCareer.job_position"
                placeholder="Posisi Yang Dilamar"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Kota Domisili"
                class="mb-0"
                v-model.trim="candidateData.candidate_place"
                placeholder="Kota Domisili"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Universitas atau Sekolah"
                class="mb-0"
                v-model.trim="candidateData.candidate_formal_education"
                placeholder="Universitas atau Sekolah"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Darimana Anda Mendapatkan Informasi Lowongan Ini"
                class="mb-0"
                v-model.trim="candidateData.candidate_referrer"
                placeholder="Darimana Anda Mendapatkan Informasi Lowongan Ini"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <p>Resume/CV</p>
              <a
                label="Resume/CV"
                :href="candidateData.attachment_resume_url"
                target="_blank"
                class="mb-0"
                placeholder="Resume/CV"
                disabled
                >{{ candidateData.attachment_resume_url }}</a
              >
            </CCol>
            <CCol :col="6">
              <p>Portfolio</p>
              <a
                label="Portfolio"
                :href="candidateData.portfolio_url"
                target="_blank"
                class="mb-0"
                placeholder="Alamat"
                disabled
                >{{ candidateData.portfolio_url }}</a
              >
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="status != 'REJECT'">
            <CCol :col="3">
              <CSelect
                label="status"
                :options="options"
                required
                v-model="candidateData.status"
                @input="handleAction"
                vertical
                placeholder="Pilih"
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="status == 'REJECT'">
            <CCol :col="6">
              <CInput
                label="Tanggal"
                class="mb-0"
                type="text"
                v-model="candidateData.updated_at"
                disabled
                vertical
              />
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="status == 'ACCEPT'">
            <CCol :col="6">
              <CInput
                label="Tanggal Masuk"
                class="mb-0"
                type="text"
                v-model="candidateData.updated_at"
                disabled
                vertical
              />
            </CCol>
          </CRow>
          <CRow class="form-froup" v-if="status == 'FOLLOW UP'">
            <CCol :col="6">
              <CTextarea
                label="Catatan"
                placeholder
                vertical
                v-model="info"
                @input="handleCatatan"
                rows="4"
              />
            </CCol>
          </CRow>
          <CRow class="form-froup" v-if="status == 'ACCEPT'">
            <CCol :col="6">
              <CTextarea
                label="Catatan"
                placeholder
                vertical
                v-model="info"
                @input="handleCatatan"
                rows="4"
              />
            </CCol>
          </CRow>
          <CRow class="form-froup" v-if="status == 'HOLD'">
            <CCol :col="6">
              <CTextarea
                label="Catatan"
                placeholder
                vertical
                v-model="info"
                @input="handleCatatan"
                rows="4"
              />
            </CCol>
          </CRow>
          <CRow class="form-froup" v-if="status == 'REJECT'">
            <CCol :col="6">
              <CTextarea
                label="Catatan"
                placeholder
                vertical
                v-model="candidateData.Histories[0].information"
                disabled
                rows="4"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="update"
                v-if="status !== 'REJECT'"
                >Save</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
        <CCardBody>
          <div class="judul">
            <strong>Action Log</strong>
          </div>

          <CDataTable
            hover
            striped
            :items="candidateData.Histories"
            :fields="fields"
          ></CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  name: "ApplicantDetail",

  data() {
    return {
      candidateData: {},
      candidateDataCareer: {},
      fields: [
        { key: "action", label: "Action" },
        { key: "information", label: "Information" },
        { key: "created_by", label: "Created By" },
        { key: "created_at", label: "Created On" },
      ],
      candidateDataUpdate: {
        action: "",
        information: "",
        status: "",
      },
      options: [
        "HR Interview",
        "1st User Interview",
        "2nd User Interview",
        "Test Case",
        "Psikotes",
        "Offering",
        "Hired",
        "Hold",
        "Vacant",
        "Sourcing",
        "Under Review (User)",
        "Closed",
        "New Request",
        "Applicantion",
        "Rejected",
        "Approach / inMail",
        "Cancel",
        "No Respons",
        "Withdraw",
        "Pool",
        "Rejected Officer",
        "Connect",
        "Cancel Join"
      ],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      info: "",
      placeBirth: "",
      status: "",
    };
  },
  mounted() {
    this.authentication();
    this.getDataByID();
  },

  methods: {
    getDataByID() {
      let candidateID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/candidate/${candidateID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.candidateData = response.data;
          this.candidateDataCareer = response.data.career;
          this.status = this.candidateData.status;
          this.candidateDataUpdate.status = this.candidateData.status;
          this.info = this.candidateData.Histories[0].information;
          this.candidateData.candidate_date_of_birth = moment(
            String(this.candidateData.candidate_date_of_birth)
          ).format("DD-MM-YYYY ");
          this.candidateData.created_at = moment(
            String(this.candidateData.created_at)
          ).utc().format("LLL");
          this.candidateData.updated_at = moment(
            String(this.candidateData.updated_at)
          ).utc().format("LLL");
          this.candidateData.Histories.forEach((element) => {
            element.created_at = moment(String(element.created_at)).utc().format(
              "LLL"
            );
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/career/applicant" });
      //  store.status = this.status
      this.$store.commit("set", this.status);
    },
    handleAction(event) {
      this.candidateDataUpdate.status = event.target.value;
    },
    handleCatatan(event) {
      this.candidateDataUpdate.information = event;
    },
    update() {
      console.log(this.candidateDataUpdate.status);
      if (
        this.candidateDataUpdate.status === "" ||
        this.candidateDataUpdate.status === "NEW"
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Action belum di pilih",
        });
      } else {
        if (this.candidateDataUpdate.action === "") {
          this.candidateDataUpdate.action = this.candidateDataUpdate.status;
        }
        if (this.candidateDataUpdate.information === "") {
          this.candidateDataUpdate.information = this.candidateDataUpdate.status;
        }
        let accountID = this.$route.params.id;
        axios
          .put(
            `${this.domain}/v1/candidate/${accountID}`,
            this.candidateDataUpdate,
            {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `Data Agent Updated`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.items = response.data;
            this.$router.push({ path: `/career/applicant` });
            this.$store.commit("set", this.status);
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message.id,
            });
            console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped>
@import "./Applicant.css";
</style>
